import React, { Component } from 'react'

class About extends Component {
    render() {
        return (
            <div>
                <center>
                    <h2>About</h2>
                    <p>This app is developed by Minh Nguyen @2020.</p>    
                </center>
            </div>
        )
    }
}

export default About
